export default {
    vc_validation_failed: '验证码输入错误，请重试',
    vc_expired: '验证码已过期，请重新获取',
    vc_validation_failed_times: '验证码输入错误次数过多，请重新获取验证码',
    blacklisted_input: '输入包含敏感词汇',
    account_not_found: '邀请人信息错误',
    invalid_param: '你已拥有自己的专属顾问，可直接咨询相关内容',
    cannot_invite_oneself: '不能邀请自己',
    invitee_already_has_inviter: '已经接受过邀请',
    invitee_is_employee: '不能邀请员工',
    invitee_is_car_owner: '被邀请人已经是车主',
    invalid_inviter: '邀请人无邀请资格'
};



// WEBPACK FOOTER //
// ./src/config/result-code.js